import { pushToDataLayer } from '../dataLayer'
import { AnalyticsFormMode, AnalyticsProductType, AnalyticsStockType } from './types'

const ProductTitleSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'dados-basicos: titulo-da-oferta',
  })
}

const ProductCharacteristicsSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'dados-basicos: caracteríticas',
  })
}

const ProductRegulatoryInformationSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'dados-basicos: informacoes-regulatorias',
  })
}

const ProductAnatelCertificationSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'dados-basicos: certificacao-e-registro-anatel',
  })
}

const ProductVariationAttributeSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'dados-basicos: variacoes-do-produto',
  })
}

const ProductVariationAttributesListSaved = (
  formMode: AnalyticsFormMode,
  attributesList: string
): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: variacoes-do-produto: ${formMode}`,
    content_id: attributesList,
  })
}

const ProductWithEANSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: variacoes-do-produto: ${formMode}`,
    content_id: 'sku-e-ean',
  })
}

const ProductWithoutEANSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: variacoes-do-produto: ${formMode}`,
    content_id: 'sku',
  })
}

const ProductVideoUploadSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: variacoes-do-produto: ${formMode}`,
    content_id: 'video-adicionado',
  })
}

const ProductDatasheetSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'ficha-tecnica:ficha-tecnica',
  })
}

const ProductPackageSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'dados-de-envio:peso-dimensões-do-produto-embalado',
  })
}

const ProductPriceSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'publicacao:preco',
  })
}

const ProductStockSaved = (formMode: AnalyticsFormMode, stockType: AnalyticsStockType): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: estoque: ${formMode}`,
    content_id: stockType,
  })
}

const ProductDescriptionSaved = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'publicacao:descreva-o-produto',
  })
}

const ProductPublishedSuccessfully = (productType: AnalyticsProductType): void => {
  pushToDataLayer({
    event: 'form_submit',
    content_type: `portal-seller:produtos: envio-do-formulario: ${productType}`,
    content_id: 'sucesso',
  })
}

export {
  ProductTitleSaved,
  ProductCharacteristicsSaved,
  ProductRegulatoryInformationSaved,
  ProductAnatelCertificationSaved,
  ProductVariationAttributeSaved,
  ProductVariationAttributesListSaved,
  ProductWithEANSaved,
  ProductWithoutEANSaved,
  ProductVideoUploadSaved,
  ProductDatasheetSaved,
  ProductPackageSaved,
  ProductPriceSaved,
  ProductStockSaved,
  ProductDescriptionSaved,
  ProductPublishedSuccessfully,
}
